import React, { useRef, useState } from 'react';
import { Popup } from 'devextreme-react';
import Form, { SimpleItem, GroupItem, Label, StringLengthRule, RequiredRule } from 'devextreme-react/form';
import http from '../../utils/http';
import uri from '../../utils/uri';
import { defaultCliente } from '../../data/cliente';
import { formatDate } from '../../data/app';
import { createStore } from '../../utils/proxy';
import { Button } from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import { ToolbarItem } from 'devextreme-react/popup';

const NuevoQuickly = props => {

    const [cliente, setcliente] = useState({ ...defaultCliente });
    const [open, setOpen] = useState(false);
    const [saving, setSaving] = useState({
        loading : false,
        text : 'Guardar'
    });
    const onHiding = () => {
        setOpen(false)
    }


    const onShowing = (e) => {
        setcliente({ ...defaultCliente });
    }

    const refForm = useRef();

    const guardarCliente = (params) => {

        let result = refForm.current.instance.validate();      

        if (result.isValid) {

            setSaving({loading : true, text:'Guardando...'});
            
            http(uri.clients.insert).asPost(cliente).then(resp => {

                notify('Datos guardados correctamente');
                setSaving({loading : false, text:'Guardar'});
                const { onSave } = props;
                var save = onSave?.();
                onHiding();

            }).catch(err => {

                setSaving({loading : false, text:'Guardar'});
                notify(err, 'error');

            });

        }
    }

    return (
        <div>
            <div style={{float:'right', marginBottom:'5px'}}>
                <Button
                    width={180}
                    text="Nuevo cliente"
                    type="normal"
                    icon='plus'
                    onClick={e => setOpen(true)}
                />
            </div>
            <Popup
                title={`Gestion de cliente`}
                width={850}
                height={320}
                onHiding={onHiding}
                onShowing={onShowing}
                visible={open}
                className="bg-fbfbfb"
            >
                <Form formData={cliente} ref={refForm} colCount={2}>
                    <SimpleItem dataField="name" colSpan={1}>
                        <Label text="Nombre" />
                        <RequiredRule message="Este campo es requerido" />
                        <StringLengthRule max={100} message="Maximo 100 caracteres" />
                    </SimpleItem>
                    <SimpleItem dataField="lastName">
                        <Label text="Apellidos" />
                        <RequiredRule message="Este campo es requerido" />
                        <StringLengthRule max={100} message="Maximo 100 caracteres" />
                    </SimpleItem>
                    <SimpleItem dataField="identification">
                        <RequiredRule message="Este campo es requerido" />
                        <Label text="Identificacion" />
                        <StringLengthRule max={50} message="Maximo 50 caracteres" />
                    </SimpleItem>
                    <SimpleItem dataField="sexId" editorType="dxSelectBox"
                        editorOptions={{
                            dataSource: createStore({name :'sex'}),
                            valueExpr: "id",
                            displayExpr: 'name',
                        }} >
                        <Label text="Sexo" />
                        <RequiredRule message="Este campo es requerido" />
                        <StringLengthRule max={1} message="Maximo 1 caracteres" />
                    </SimpleItem>
                    <SimpleItem dataField="categoryId" editorType="dxSelectBox"
                        editorOptions={{
                            dataSource: createStore({name :'category'}),
                            valueExpr: "id",
                            displayExpr: 'name',
                        }} >
                        <Label text="Categoria" />
                        <RequiredRule message="Este campo es requerido" />
                    </SimpleItem>
                    <SimpleItem dataField="fileNumber">
                        <Label text="Expediente" />
                        <StringLengthRule max={50} message="Maximo 50 caracteres" />
                        <RequiredRule message="Este campo es requerido" />
                    </SimpleItem>
                    <SimpleItem dataField="active" editorType="dxSwitch" editorOptions={{
                        switchedOffText: "No",
                        switchedOnText: "Si",
                    }}>
                        <Label text="Activo" />
                    </SimpleItem>
                    <SimpleItem dataField="sendNotification" editorType="dxSwitch" editorOptions={{
                        switchedOffText: "No",
                        switchedOnText: "Si",
                    }}>
                        <Label text="Aviso de cumpleaños?" />
                    </SimpleItem>
                </Form>
                <br />
                <Button
                    width={180}
                    text={saving.text} 
                    disabled={saving.loading}
                    type="default"
                    icon='save'
                    onClick={guardarCliente}
                />
                <br />
            </Popup>
        </div>
    );
}

export default NuevoQuickly;
